<template>
    <path d="M 0.39755873,23.506568 C 0.41083405,23.45244 0.73574232,21.992656 1.1195828,20.26261 L 1.8174736,17.11707 8.5418383,10.392706 15.266202,3.6683421 17.810962,6.2131017 20.355721,8.7578603 13.64686,15.466898 6.938,22.175934 3.7204698,22.89046 c -1.7696417,0.39299 -3.2466702,0.714526 -3.28228637,0.714526 -0.035615,0 -0.053897,-0.04429 -0.0406217,-0.09842 z M 16.011145,8.0130549 15.378533,7.380443 10.289376,12.469367 5.2002194,17.55829 5.832049,18.191917 6.4638787,18.825545 11.553818,13.735606 16.643757,8.6456668 Z M 18.893931,5.1025916 16.3639,2.5720932 17.150754,1.7835555 C 17.8334,1.0994472 17.997191,0.96574073 18.38752,0.77394972 c 1.650347,-0.81090931 3.600557,-0.28559685 4.617238,1.24370808 0.76386,1.1490099 0.804173,2.6757596 0.101682,3.850949 -0.164797,0.2756875 -1.559793,1.7644832 -1.653314,1.7644832 -0.01604,0 -1.167678,-1.1387244 -2.559195,-2.5304984 z"/>
</template>

<script>
    export default {
        name: 'pencil',
    }
</script>



// WEBPACK FOOTER //
// src/components/icon/Pencil.vue